import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import pixpasarelas from '../../../assets/images/PIXPASA1.png';
import Rbetterbro from '../../../assets/images/RETIRACONBETTERBRO.svg';

const FormPix = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("");

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  const handleMethodChange = (e) => {
    handleChange(e);
    setSelectedMethod(e.target.value); 
  };

  return (
    <Form>
      <InputContainer>
        <label>{t("deposit.methodPayment")}:</label>
        <select value={form.metodo} onChange={handleMethodChange} name = 'metodo'>
          <option value="">{t("deposit.selectpayment")}</option>
          <option value="email">EMAIL</option>
          <option value="telefono">{t("deposit.telefono")}</option>
          <option value="documento">{t("deposit.dni")}</option>
        </select>
      </InputContainer>

      {selectedMethod === "email" && (
        <InputContainer>
          <label>{t("sign-in.lbl-email")}:</label>
          <input
            type="text"
            placeholder={t("sign-in.lbl-email")}
            name="email"
            value={form.email}
            onChange={handleChange}
          />
        </InputContainer>
      )}

      {selectedMethod === "telefono" && (
        <InputContainer>
          <label>{t("deposit.telefono")}:</label>
          <input
            type="text"
            placeholder={t("deposit.telefono")}
            name="telefono"
            value={form.telefono}
            onChange={handleChange}
          />
        </InputContainer>
      )}

      {selectedMethod === "documento" && (
        <InputContainer>
          <label>{t("deposit.cpf")}:</label>
          <input
            type="text"
            placeholder={t("deposit.cpf")}
            name="cpf"
            value={form.cpf}
            onChange={handleChange}
          />
        </InputContainer>
      )}

      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto"
          value={form.monto}
          onChange={(e) => handleMonto(e)}
        />

        {monto < 50 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 50 {moneda}{" "}
          </ErrorSpan>
        )}
        {monto > 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000 {moneda}{" "}
          </ErrorSpan>
        )}
      </InputContainer>

      <img
        src={Rbetterbro}
        alt="Rbetterbro"
        className={"tupa1"}
        style={{ width: "40%", marginLeft: "30%", marginTop: "5%" }}
      />

      <img
        src={pixpasarelas}
        alt="Pasarelas PIX"
        className={"tupa2"}
        style={{ width: "100%", marginTop: "0.5%", marginLeft: "0.2%" }}
      />

      <ButtonsContainerRetiro style={{ marginTop: "-160px" }}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={loading || monto < 50 || monto > 5000}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormPix;
